import React, { useState, useEffect, useContext, useCallback } from 'react';
// import usePriceSeprator from "../../../hooks/usePriceSeparator"
import axios from '../../../axios/index';
import { Link, useLocation } from 'react-router-dom';

// Context
import { UserContext } from '../../Context/UserContextProvider';

// Styles
import styles from "./DashboardFileManagement.module.css"

// Re Useable Components
import DashboardSideMenu from '../DashboardReuseAbleComponents/DashboardSideMenu';
import DashboardHeader from '../DashboardReuseAbleComponents/DashboardHeader';
import ShowProfileModal from './CardDetail/ShowProfileModal'

//Images
// import cardImg from "../../../assets/img/DashboardICons/cardImgTest.png"
import bedIcon from "../../../assets/img/DashboardICons/bedIcon.svg"
import meterIcon from "../../../assets/img/DashboardICons/meterIcon.svg"
import buildingIcon from "../../../assets/img/DashboardICons/buildingIcon.svg"
import locationIcon from "../../../assets/img/DashboardICons/locationIcon.svg"
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const MultipleStoryCard = (props) => {
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const { userToken } = useContext(UserContext);
    const { state } = useLocation();
    const [modalShow, setModalShow] = useState(false);
    const [cardData, setCardData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory();
    const getDataHandler = useCallback(async () => {
        try {
            const { data } = await axios.get(`Estate/GetEstateChilds?parentId=${state.state.id}`, {
                headers: { authorization: "Bearer " + userToken },
            });
            // console.log(data)

            const salesData = data?.data || [];
            // console.log(test.length)
            setCardData(salesData);
            setIsLoading(false);
        } catch (error) {
            //console.error(error);
        }
    }, [state, userToken]);

    useEffect(() => {
        getDataHandler();
    }, [getDataHandler]);

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            {isLoading ? (
                <div className={styles.loader_container}>
                    <div className={styles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`mt-3 px-md-0 px-2 ${styles.file_cards_container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} class="px-3" />
                                    <div className="py-2">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                                    <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                                    <div className={`d-flex align-items-center justify-content-center ${styles.text1}`}>
                                                        <p className={`mx-1 mb-0`}>
                                                            {e2p(cardData.length)}
                                                            {/* {state.state.title} */}
                                                        </p>
                                                        عدد فایل
                                                        {/* فایل های موجود در فایل */}
                                                        {/* <p className={`me-2 mb-0 ${styles.card_price}`}>
                                                        {e2p(cardData.length)}
                                                            {state.state.title}
                                                        </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`w-100 d-flex justify-content-xl-between justify-content-center flex-wrap align-items-center mt-3 me-3 ${styles.cards_container}`} dir="rtl">
                                        {cardData == "" ?
                                            <div className={`w-100 d-flex align-items-center justify-content-center ${styles.notfound_text}`}>
                                                هنوز هیچ موردی برای نمایش وجود ندارد
                                            </div>
                                            :
                                            state.filterCardsByCategory.forRent === true ?
                                                cardData?.map((item, i) => (
                                                    <div key={i} className={`d-flex align-items-center flex-column px-2 py-3 my-3 mx-2 ${styles.multiple_card_container}`}>
                                                        <Link to={{
                                                            pathname: `/card-detail/${item.id}`,
                                                            state: {
                                                                state: item,
                                                                isArchive: props.isArchive ? true : false
                                                            }
                                                        }}>
                                                            <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                                                        </Link>
                                                        {item.status === 4 &&
                                                            <span className={`d-flex align-items-center justify-content-center ${styles.card_imgs_nubmer_info}`}>
                                                                نیاز به تایید
                                                            </span>
                                                        }
                                                        {item.isAnyChild &&
                                                            <span className={`d-flex align-items-center justify-content-center ${styles.card_multiple_text}`}>
                                                                چند واحدی
                                                            </span>
                                                        }

                                                        <div className='w-100 text-end px-2 mb-1'>
                                                            <Link to={{
                                                                pathname: `/card-detail/${item.id}`,
                                                                state: {
                                                                    state: item,
                                                                    isArchive: props.isArchive ? true : false
                                                                }
                                                            }} className={styles.card_title}>{e2p(item.title?.toString())}</Link>
                                                        </div>

                                                        <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                                                            <div className='w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2'>
                                                                <div className={`ms-2 ${styles.rent_title}`}>
                                                                    رهن:
                                                                </div>
                                                                <div className={styles.card_price}>
                                                                    {e2p(item.mortgagePrice)?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}<span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                                                                </div>
                                                            </div>
                                                            <div className='w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2'>
                                                                <div className={`ms-2 ${styles.rent_title}`}>
                                                                    اجاره:
                                                                </div>
                                                                <div className={styles.card_price}>
                                                                    {e2p(item.rentPrice)?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}<span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap">
                                                            <div className='d-flex align-items-center justify-content-center flex-column'>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={bedIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        {e2p(item.roomCount?.toString())} خوابه
                                                                    </div>

                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={meterIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        {e2p(item.meterage?.toString())} متر
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center justify-content-center flex-column'>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={buildingIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        طبقه {e2p(item.floor?.toString())}
                                                                    </div>

                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={locationIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        {item.address.zone}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="w-100 d-flex justify-content-center justify-content-md-end align-items-center px-2">
                                                            <div className='d-flex align-items-center justify-content-center'>
                                                                <Link to={{
                                                                    pathname: `/card-detail/${item.id}`,
                                                                    state: {
                                                                        state: item,
                                                                        isArchive: props.isArchive ? true : false
                                                                    }
                                                                }} className={`ms-1 ${styles.text_primary}`}>
                                                                    مشاهده بیشتر
                                                                </Link>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" fill="#21409A" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                cardData?.map((item, i) => (
                                                    <div key={i} className={`d-flex align-items-center flex-column px-2 py-3 my-3 mx-2 ${styles.multiple_card_container}`}>
                                                        <Link to={{
                                                            pathname: `/card-detail/${item.id}`,
                                                            state: {
                                                                state: item,
                                                                isArchive: props.isArchive ? true : false
                                                            }
                                                        }}>
                                                            <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                                                        </Link>
                                                        {item.status === 4 &&
                                                            <span className={`d-flex align-items-center justify-content-center ${styles.card_imgs_nubmer_info}`}>
                                                                نیاز به تایید
                                                            </span>
                                                        }
                                                        {item.isAnyChild &&
                                                            <span className={`d-flex align-items-center justify-content-center ${styles.card_multiple_text}`}>
                                                                چند واحدی
                                                            </span>
                                                        }

                                                        <div className='w-100 text-end px-2 mb-1'>
                                                            <Link to={{
                                                                pathname: `/card-detail/${item.id}`,
                                                                state: {
                                                                    state: item,
                                                                    isArchive: props.isArchive ? true : false
                                                                }
                                                            }} className={styles.card_title}>{e2p(item.title?.toString())}</Link>
                                                        </div>

                                                        <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                                                            <h4 className={styles.card_price}>{e2p(item.totalPrice)?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}<span className={`me-1 ${styles.card_text2}`}>تومان</span></h4>
                                                            <h4 className={`d-flex align-items-center justify-content-center ${styles.card_text2}`}>{e2p(item.meteragePrice)?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} تومان هر متر مربع</h4>
                                                        </div>

                                                        <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap">
                                                            <div className='d-flex align-items-center justify-content-center flex-column'>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={bedIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        {e2p(item.roomCount?.toString())} خوابه
                                                                    </div>

                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={meterIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        {e2p(item.meterage?.toString())} متر
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center justify-content-center flex-column'>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={buildingIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        طبقه {e2p(item.floor?.toString())}
                                                                    </div>

                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                                    <img className="ms-2" src={locationIcon} alt="icon" />
                                                                    <div className={styles.card_text2}>
                                                                        {item.address.zone}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="w-100 d-flex justify-content-center justify-content-md-end align-items-center px-2">
                                                            <div className='d-flex align-items-center justify-content-center'>
                                                                <Link to={{
                                                                    pathname: `/card-detail/${item.id}`,
                                                                    state: {
                                                                        state: item,
                                                                        isArchive: props.isArchive ? true : false
                                                                    }
                                                                }} className={`ms-1 ${styles.text_primary}`}>
                                                                    مشاهده بیشتر
                                                                </Link>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" fill="#21409A" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu manageFiles />
                                {/* sideMenu ends */}
                            </div>
                        </div >
                    </div >
                )}
        </>
    );
};

export default MultipleStoryCard;